import { useMemo } from "react";

const useMemoArray = <T extends any[]>(array: T): T => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const res = useMemo(() => array, array);
  return res;
};

export default useMemoArray;
